var map = {
	"./images/Genomii_logo.svg": 4901,
	"./images/aging-process.png": 6283,
	"./images/double_helix.png": 9477,
	"./images/floating-cards/GoalCard_Appearance-default.png": 1070,
	"./images/floating-cards/GoalCard_Appearance-hovered.png": 6884,
	"./images/floating-cards/GoalCard_Diet-default.png": 5694,
	"./images/floating-cards/GoalCard_Diet-hovered.png": 3236,
	"./images/floating-cards/GoalCard_Emotions-default.png": 4282,
	"./images/floating-cards/GoalCard_Emotions-hovered.png": 7736,
	"./images/floating-cards/GoalCard_Energy-default.png": 5424,
	"./images/floating-cards/GoalCard_Energy-hovered.png": 4686,
	"./images/icn_appfeature1.png": 9854,
	"./images/icn_appfeature2.png": 7685,
	"./images/icn_appfeature3.png": 1772,
	"./images/joinus-bg.png": 6719,
	"./vectors/GENNI.svg": 5834,
	"./vectors/aging_txt_mobile.svg": 9555,
	"./vectors/aging_txt_pc.svg": 8990,
	"./vectors/avatar/avr_emily.svg": 3725,
	"./vectors/avatar/avr_mia.svg": 7548,
	"./vectors/avatar/avr_sara.svg": 3190,
	"./vectors/circle-decoration.svg": 1348,
	"./vectors/footer_youtube1.svg": 4903,
	"./vectors/footer_youtuve2.svg": 9520,
	"./vectors/icn_quotation.svg": 5378,
	"./vectors/joinWaitlist-default.svg": 5454,
	"./vectors/joinWaitlist-hover.svg": 8515,
	"./vectors/joinus-genni.svg": 267,
	"./vectors/nameCard/bgd_sally.svg": 4920,
	"./vectors/nameCard/btn_genomiiwebsite.svg": 8473,
	"./vectors/nameCard/btn_schedulemeeting.svg": 5520,
	"./vectors/nameCard/btn_youtubechannel.svg": 2178,
	"./vectors/nameCard/icn_email.svg": 3964,
	"./vectors/nameCard/icn_instagram.svg": 3872,
	"./vectors/nameCard/icn_linkedin.svg": 3962,
	"./vectors/nameCard/icn_whatsapp.svg": 9462,
	"./vectors/next_button.svg": 3037,
	"./vectors/read-now-btn-default.svg": 9365,
	"./vectors/read-now-btn-hover.svg": 4428,
	"./vectors/rotating_words/txt_dermatologist.svg": 8437,
	"./vectors/rotating_words/txt_fitness.svg": 1023,
	"./vectors/rotating_words/txt_holistic.svg": 8914,
	"./vectors/rotating_words/txt_nutritionist.svg": 1865,
	"./vectors/rotating_words/txt_therapist.svg": 4645,
	"./vectors/whycards/bdg_card1.svg": 2676,
	"./vectors/whycards/bdg_card2.svg": 887,
	"./vectors/whycards/bdg_card3.svg": 7062,
	"./vectors/whycards/bdg_card4.svg": 3449,
	"./vectors/whycards/cnt_card1.svg": 1384,
	"./vectors/whycards/cnt_card2.svg": 3275,
	"./vectors/whycards/cnt_card3.svg": 4458,
	"./vectors/whycards/cnt_card4.svg": 3557,
	"./videos/vdo_geniipage_mobile.mp4": 9272,
	"./videos/vdo_geniipage_pc.mp4": 6969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;